'use strict';

(function() {
	angular.module('onboarding.common')
		.directive('cobMultipleCarriers', cobMultipleCarriers);

	cobMultipleCarriers.$inject = [
		'$log', '$timeout', '$state', 'subjectObserverMessagesService', 'observerService', 'sessionService',
		'carrierRegistrationService'
	];

	var $log,
		$timeout,
		$state,
		subjectObserverMessagesService,
		observerService,
		sessionService,
		subjectMessages,
		observerMessages,
		carrierRegistrationService;

	function cobMultipleCarriers(_$log_,
		_$timeout_,
		_$state_,
		_subjectObserverMessagesService_,
		_observerService_,
		_sessionService_,
		_carrierRegistrationService_) {
		$log = _$log_;
		$timeout = _$timeout_;
		$state = _$state_;
		subjectObserverMessagesService = _subjectObserverMessagesService_;
		observerService = _observerService_;
		sessionService = _sessionService_;
		carrierRegistrationService = _carrierRegistrationService_;

		return {
			restrict: 'E',
			scope: {
				visible: '=',
				carrierList: '='
			},
			replace: true,
			templateUrl: '/app/common/welcome/multipleCarriers.html',
			link: linkFunction
		};
	}

	function linkFunction(scope) {

		activate();

		function activate() {
			subjectMessages = subjectObserverMessagesService.getSubjectMessages();
			observerMessages = subjectObserverMessagesService.getObserverMessages();

			scope.m = {
				carrier: {},
				errorMessage: ''
			};

			scope.setActiveSlide = setActiveSlide;
			scope.submitClick = submitClick;
			scope.backToDot = backToDot;
		}

		function setActiveSlide(slide) {
			scope.m.errorMessage = '';
			scope.m.carrier = {},
			observerService.sendMessageToSubject(scope,
				subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_CHANGE_WELCOME_VIEW,
				{
					setActiveSlide: slide
				});
		}

		function submitClick() {
			if (!scope.m.carrier.tCoreId) {
				scope.m.errorMessage = 'You must choose from the list to continue.';
			} else {
				scope.m.errorMessage = '';

				carrierRegistrationService.setCarrier(scope.m.carrier);
				$state.transitionTo('registration');
			}
		}

		function backToDot() {
			scope.m.errorMessage = '';
			setActiveSlide('dotNumberSection');
		}
	}

})();
